export const CODE_BLOODED = "Code Blooded";
export const CODE_BENDER = "Code Bender";
export const COMMITTER = "Committer";
export const LEAD_DISRUPTOR = "Lead Disruptor";

export const USER_FIELD_EMAIL = "email";
export const USER_FIELD_USER_ID = "userId";
export const USER_FIELD_CATEGORY = "category";
export const USER_FIELD_MEMBER_ID = "affiliateId";

export const USER_LABEL_EMAIL = "Email";
export const USER_LABEL_USER_ID = "User ID";
export const USER_LABEL_CATEGORY = "Category";
export const USER_LABEL_MEMBER_ID = "Member ID";

export const USER_CATEGORY_MEMBER = "member";
export const USER_CATEGORY_AFFILIATE = "affiliate";
export const USER_CATEGORY_REFERRER = "referrer";
export const USER_CATEGORY_PARTNER = "partner";
export const USER_CATEGORY_PANELIST = "panelist";

export const USER_STATUS_DEFAULT = "default";
export const USER_STATUS_FLAGGED = "flagged";
export const USER_STATUS_BANNED = "banned";

export const PANEL_STATUS_DEFAULT = "default";
export const PANEL_STATUS_PENDING = "pending";
export const PANEL_STATUS_APPROVED = "approved";
export const PANEL_STATUS_REJECTED = "rejected";

export const VERIFICATION_STATUS_DEFAULT = "default";
export const VERIFICATION_STATUS_MANUAL = "manual";
export const VERIFICATION_STATUS_SSO = "sso";

export const POINTS_REASON_BLOG_POST = "blog_post";
export const POINTS_REASON_COMITTEE = "committee";
export const POINTS_REASON_FEEDBACK = "feedback";
export const POINTS_REASON_FEEDBACK_NEWSLETTER = "feedback_newsletter";
export const POINTS_REASON_FEEDBACK_REBRANDING = "feedback_rebranding";
export const POINTS_REASON_GOODYBAG_FEEDBACK = "goodybag-feedback";
export const POINTS_REASON_INTERVIEW = "interview";
export const POINTS_REASON_PULSE_FEEDBACK = "pulse-feedback";
export const POINTS_REASON_SON_FEEDBACK = "son-feedback";
export const POINTS_REASON_SURVEY = "survey";
export const POINTS_REASON_UIUX_POLL = "ui/ux-poll";
export const POINTS_REASON_REDEMPTION = "redemption";

export const reasons = [
  {
    key: POINTS_REASON_BLOG_POST,
    value: "blog post",
  },
  {
    key: POINTS_REASON_COMITTEE,
    value: "committee",
  },
  {
    key: POINTS_REASON_FEEDBACK,
    value: "feedback",
  },
  {
    key: POINTS_REASON_FEEDBACK_NEWSLETTER,
    value: "feedback newsletter",
  },
  {
    key: POINTS_REASON_FEEDBACK_REBRANDING,
    value: "feedback rebranding",
  },
  {
    key: POINTS_REASON_GOODYBAG_FEEDBACK,
    value: "goodybag feedback",
  },
  {
    key: POINTS_REASON_INTERVIEW,
    value: "interview",
  },
  {
    key: POINTS_REASON_PULSE_FEEDBACK,
    value: "pulse feedback",
  },
  {
    key: POINTS_REASON_SON_FEEDBACK,
    value: "son feedback",
  },
  {
    key: POINTS_REASON_SURVEY,
    value: "survey",
  },
  {
    key: POINTS_REASON_UIUX_POLL,
    value: "ui/ux poll",
  },
  {
    key: POINTS_REASON_REDEMPTION,
    value: "redemption",
  },
];

export const PARAMS_TO_PRESERVE = [
  "member_id",
  "ext_uuid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
];
